import React from 'react';
import {divideThousandsInteger} from '../../../../../utils/format';
import styles from './styles.module.scss';
import themeStyles from '../../../_common/styles/theme.module.scss';
import {useGlobalContext} from "../../../_common/contexts/GlobalContext";
import classnames from "classnames";

const InfoBox = ({label, value}) => {
  const {isGlassTheme} = useGlobalContext();

  return (
    <div className={classnames(styles.infoBox,
      isGlassTheme ? themeStyles.jump : themeStyles.noJump
    )}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{divideThousandsInteger(value)}</div>
    </div>
  );
};

export default InfoBox;
